
const AccessDenied = () =>{

    return(
        <section>
            <div className="mt-4">
                <div style={{marginTop:"60px"}} className="container">
                    <h2 className="text-center">You do not have access to this page</h2>
                </div>
            </div>
        </section>
    )
    
}

export default AccessDenied;